import { memo } from 'react'
import { BgColor, MlRichTextProps, OrCollapseContainer, OrCollapseProps } from '@curran-catalog/curran-atomic-library'
import { ContentfulObjFlooringWeave, SiteDomain } from 'types'
import { environment } from '@config/environment'
import { SpecificationsContent } from './specifications-content'

const CollapseSectionComponent = ({ product }: { product: ContentfulObjFlooringWeave }) => {
  const isSynsisal = environment.siteDomain === SiteDomain.SYNSISAL
  const bgColor = isSynsisal ? BgColor.BLACK : BgColor.MOSS

  const collapseItems: OrCollapseProps[] = []

  collapseItems.push({
    id: 0,
    isOpen: true,
    title: 'Specifications',
    idTarget: 'GeneralSpecifications',
    content: <SpecificationsContent product={product} />,
    bgColor,
  })

  product?.careInformation &&
    collapseItems.push({
      id: 1,
      isOpen: true,
      title: 'Care',
      idTarget: 'CareSpecifications',
      content: [{ text: product?.careInformation.description }] as MlRichTextProps[],
      bgColor,
    })

  product?.installationInformation &&
    collapseItems.push({
      id: 2,
      isOpen: true,
      title: 'Installation',
      idTarget: 'InstallationSpecifications',
      content: [{ text: product?.installationInformation.description }] as MlRichTextProps[],
      bgColor,
    })

  product?.vendor?.flooringDeliveryInfo &&
    !isSynsisal &&
    collapseItems.push({
      id: 3,
      idTarget: 'ShippingSpecifications',
      isOpen: true,
      title: 'Shipping',
      content: [
        product.uniqueShippingDescription
          ? { text: product.uniqueShippingDescription }
          : { text: product.vendor.flooringDeliveryInfo },
      ] as MlRichTextProps[],
      bgColor,
    })

  return <OrCollapseContainer className="" collapseItems={collapseItems} />
}

export const CollapseSection = memo(CollapseSectionComponent)
